import { Directive } from '@angular/core';

/** Can be used to override the icon of a `erDatepickerToggle`. */
@Directive({
	selector: '[erDatepickerToggleIcon]'
})
export class DatepickerToggleIconDirective {}
